import RecipeListingPageLayout from './RecipeListingPageLayout';

export default RecipeListingPageLayout;
